'use strict';

var GridToolbarFaresContributingFBCsDirective = function GridToolbarFaresContributingFBCsDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-fares-contributing-fbcs.html'),
    controller: 'GridToolbarFaresContributingFBCsController',
    link: function link($scope, $element) {
      $scope.$on('keyboard:save', function (ev) {
        if (isDisplayed()) {
          $scope.saveChanges();
        }
        ev.preventDefault();
        return false;
      });
      function isDisplayed() {
        return $element.css('display') !== 'none' && $element.css('visibility') !== 'hidden';
      }
    }
  };
};
GridToolbarFaresContributingFBCsDirective.$inject = [];
module.exports = GridToolbarFaresContributingFBCsDirective;